import { render } from "./RightArrowIcon.vue?vue&type=template&id=1c20e3d2"
import script from "./RightArrowIcon.vue?vue&type=script&lang=js"
export * from "./RightArrowIcon.vue?vue&type=script&lang=js"
script.render = render

export default script